import {Button, Container, Grid2, useTheme} from "@mui/material";
import { makeStyles } from "@mui/styles";
import StatusHandler from "components/common/StatusHandler";
import { ACTION_STATES } from "core/actions";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ContactSerch from "./ContactSearch";
import InfoSection from "./InfoSection";
import { actions } from "./logic/contactActions";
import "./styles.scss";
import useMediaQuery from "@mui/material/useMediaQuery";
import {SMALL_DEVICE_MEDIA_SIZE} from "components/common/constants";
import FullScreenModal from "components/common/FullScreenModal";
import globalActions from "components/global/logic/actions";

const styles = () => ({
    leftContainer: {},
    rightContainer: {
        "& .MuiInputBase-root.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.60) !important",
        },
    },
});

const useStyle = makeStyles(styles);

function Contact({
                     savingContactStatus,
                     savingCompanyStatus,
                     removingContactStatus,
                     removingCompanyStatus,
                     clearStatus,
                     error,
                     onCloseGlobalSearch,
                     globalSearchOpen,
                     clearForm
                 }){
    const classes = useStyle();
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE));


    const [status, setStatus] = useState(ACTION_STATES.NO_REQUEST);

    useEffect(() => {
        _get_status();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [savingContactStatus, savingCompanyStatus, removingContactStatus, removingCompanyStatus]);

    function handleClose() {
        setStatus(ACTION_STATES.NO_REQUEST);
        clearStatus();
    }
    function _get_status() {
        const statusList = [savingContactStatus, savingCompanyStatus, removingContactStatus, removingCompanyStatus];
        let returnStatus = ACTION_STATES.NO_REQUEST;
        for (let currentStatus of statusList) {
            if (currentStatus === ACTION_STATES.FAILED) {
                returnStatus = ACTION_STATES.FAILED;
                break;
            } else if (currentStatus === ACTION_STATES.SEND) {
                returnStatus = ACTION_STATES.SEND;
            } else if (currentStatus === ACTION_STATES.SUCCESS && returnStatus !== ACTION_STATES.SEND)
                returnStatus = ACTION_STATES.SUCCESS;
        }
        setStatus(returnStatus);
    }

    function onClearModal() {
        clearStatus();
        onCloseGlobalSearch();
    }
    const btnsModal = (
        <React.Fragment>
            {}
            <Button variant={"contained"} size={"small"} onClick={onClearModal} style={{ marginRight: 5 }}>
                Reset
            </Button>
            <Button variant={"contained"} size={"small"} color={"secondary"} onClick={onCloseGlobalSearch}>
                Select
            </Button>
        </React.Fragment>
    );
    const contactSearch = <ContactSerch />
    return (
        <Container maxWidth={"xl"} className={"atsGlobalContainer"}>
            <StatusHandler
                status={status}
                showLoading={status === ACTION_STATES.SEND}
                onClose={handleClose}
                error={error}
            />
            <Grid2 container direction="row" alignContent={"flex-start"} justify={"flex-start"} spacing={3}>
                <FullScreenModal
                    btns={btnsModal}
                    title={"Filter"}
                    handleClose={onCloseGlobalSearch}
                    open={globalSearchOpen}>
                    <Grid2 sx={{ display: {sm: "block", xs: "block", md: "block", xl: "none", lg: "none"}}}
                           style={{marginTop: 20}}>
                        {contactSearch}
                    </Grid2>
                </FullScreenModal>
                {!isSmallDevice && (
                    <Grid2
                        direction="column"
                        className={classes.leftContainer}
                        size={{
                            md: 4,
                            xl: 3
                        }}>
                        <ContactSerch />
                    </Grid2>
                )}
                <Grid2
                    direction="column"
                    className={classes.rightContainer}
                    size={{
                        md: 8,
                        xl: 9
                    }}>
                    <InfoSection />
                </Grid2>

            </Grid2>
        </Container>
    );
};

Contact.propTypes = {
    savingContactStatus: PropTypes.string,
    savingCompanyStatus: PropTypes.string,
    removingContactStatus: PropTypes.string,
    removingCompanyStatus: PropTypes.string,
    clearStatus: PropTypes.func,
    error: PropTypes.string,
};
const mapStateToProps = (state) => ({
    error: state.contacts.error,
    savingContactStatus: state.contacts.savingContactStatus,
    savingCompanyStatus: state.contacts.savingCompanyStatus,
    removingContactStatus: state.contacts.removingContactStatus,
    removingCompanyStatus: state.contacts.removingCompanyStatus,
    globalSearchOpen: state.globalApp.globalSearchOpen
});

const mapStateToDispatch = (dispatch) => ({
    clearStatus: () => dispatch(actions.CLEAR_STATUS.call()),
    onCloseGlobalSearch: () => dispatch(globalActions.TOGGLE_GLOBAL_SEARCH_BTN.call(false)),
});

export default connect(mapStateToProps, mapStateToDispatch)(Contact);
